export const AGENTS = {
    office: {
        name: 'office',
        display_name: 'Office Assistant',
        color: '#4A90D9',
        icon: 'fa-light fa-lamp-desk',
        short_description: 'Navigate & Act'
    },
    data: {
        name: 'data',
        display_name: 'Data Assistant',
        color: '#7B68EE',
        icon: 'fa-light fa-chart-sine',
        short_description: 'Export & Analyze'
    },
    compliance: {
        name: 'compliance',
        display_name: 'Compliance Assistant',
        color: '#E57373',
        icon: 'fa-light fa-square-c',
        short_description: 'Submit & Track'
    },
    field: {
        name: 'field',
        display_name: 'Field Assistant',
        color: '#F5A623',
        icon: 'fa-light fa-wrench',
        short_description: 'Look Up & Spec'
    }
};
export const AGENT_LIST = Object.values(AGENTS);
